
import Vue from "vue";
import Component from "vue-class-component";

import StringField from "../../../../shared/fields/StringField.vue";
import DateField from "../../../../shared/fields/DateField.vue";
import RequiredSexe from "../../../../shared/fields/RequiredSexe.vue";
import OptionPrixCampField from "../../../../shared/fields/OptionPrixCampField.vue";
import OptionPrixParticipantField from "../../../../shared/fields/OptionPrixParticipantField.vue";
import BusParticipant from "../../../../shared/fields/BusParticipant.vue";
import MaterielSkiParticipant from "../../../../shared/fields/MaterielSkiParticipant.vue";

import {
  ParticipantInscription,
  OptionPrixCamp,
  Camp
} from "@/shared/logic/types";
import { C } from "../controller";
import {
  hasBus,
  hasMaterielSki,
  age,
  formatDate,
  isQuotientFamilialActif
} from "../../../../shared/logic/utils";
import MultiLine from "@/shared/fields/MultiLine.vue";

const DetailsParticipantProps = Vue.extend({
  props: {
    participant: Object as () => ParticipantInscription,
    validated: Boolean
  },
  model: {
    prop: "participant",
    event: "change"
  }
});

@Component({
  components: {
    StringField,
    DateField,
    RequiredSexe,
    OptionPrixCampField,
    OptionPrixParticipantField,
    BusParticipant,
    MaterielSkiParticipant,
    MultiLine
  }
})
export default class DetailsParticipant extends DetailsParticipantProps {
  formatDate = formatDate;
  get camp(): Camp | null {
    return C.getCamp(this.participant.id_camp);
  }

  get hasOptionPrix() {
    const camp = this.camp;
    return (
      camp != null &&
      ((camp.option_prix && camp.option_prix.active) ||
        isQuotientFamilialActif(camp.quotient_familial))
    );
  }

  get choixCamps() {
    if (C.data == null) return [];
    return (C.data.camps || []).map(camp => {
      return { value: camp.id, text: camp.label };
    });
  }

  get showBus() {
    return hasBus(this.camp);
  }

  get showMaterielSki() {
    return hasMaterielSki(this.camp);
  }

  // renvoie l'âge en début de camp s'il est invalid, null sinon
  get avertissementAge(): number | null {
    const camp = this.camp;
    if (camp == null || this.participant.date_naissance == "") return null;
    const ageDebut = age(
      new Date(camp.date_debut),
      this.participant.date_naissance
    );
    if (ageDebut == null) return null;
    const isInvalid =
      (camp.age_min && ageDebut < camp.age_min) ||
      (camp.age_max && ageDebut > camp.age_max);
    if (isInvalid) return ageDebut;
    return null;
  }
}
